import React from 'react';
import './_styles.scss';
import { UserPermissions } from '../../../../../src/definitions';
import { securityService } from '../../../../../src/_global/services';
import { ISubscriptionTiers } from '../../types';

interface FancyCardProps {
  data: ISubscriptionTiers;
}

export default function FancyCard({ data }: FancyCardProps) {
  const { tier } = data;
  return securityService.checkRoleAccess(UserPermissions.viewSubscription) ? (
    <p className='fancy-card'>{tier}</p>
  ) : (
    <p></p>
  );
}
